import React from 'react';

// Hooks and Redux
import {
    useAppDispatch,
    useAppSelector
} from "../../../redux/hooks";

import {
    fetchDocumentByUser
} from '../../../redux/slices/documentsSlice';

import jwtDecode from "jwt-decode";
import {
    useForm
} from "react-hook-form";
import Swal from 'sweetalert2';
import {
    MultipleFileUpload,
    MultipleFileUploadStatusItem,
} from '@patternfly/react-core';
import "@patternfly/react-core/dist/styles/base.css";
import Typography from '@mui/material/Typography';
import {
    useTranslation
} from "react-i18next";
import Grid from '@mui/material/Grid';
import './index.scss';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CircularProgress from '@mui/material/CircularProgress';
// import { Stack } from "@mui/material"

import { Link as ReactRouterLink, useNavigate } from "react-router-dom"
import { ThemeProvider } from '@emotion/react';
import theme from "../../../styles/theme"

import { useTheme } from "@mui/material/styles"
import Dialog from "@mui/material/Dialog"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
// import Checkbox from "@mui/material/Checkbox"
// import FormControlLabel from "@mui/material/FormControlLabel"
import { green } from "@mui/material/colors"

// Services
import {
  sendFilesDocuments,
  deleteDocuments,
} from "../../../services/UserService"

// Utils
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

// Types
import { TokenPayload } from "../../../@types"

interface readFile {
  fileName: string
  data?: string
  loadResult?: "danger" | "success"
  loadError?: DOMException
}

interface documentFile {
  id: string
  name: string
  type: string
  dmsFileId: string
}

const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2MB in bytes

export interface InputDataToECProps {
  userId: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: boolean) => void
}

export default function UploadFileDocs(props: InputDataToECProps) {
  const { userId, onClose, open, ...other } = props
  // const navigate = useNavigate()
  const { t } = useTranslation()
  const themeUI = useTheme()

    // const formValidationSchema = yup.object().shape({
    //   nameFile: yup.string().required(`${t("File Name is required")}`),
    // })
  
    const {
      // register,
      handleSubmit,
      formState: { errors },
    } = useForm({
      // resolver: yupResolver(formValidationSchema),
    })
    // const navigate = useNavigate()
    // const { data } = props;
  
    const token = localStorage.getItem("access_token") || ""
    const decoded: TokenPayload = jwtDecode(token)
  
    const [userFiles, setUserFiles] = React.useState<File[]>([])
    const [currentFiles, setCurrentFiles] = React.useState<File[]>([])
    const [readFileData, setReadFileData] = React.useState<readFile[]>([])
    const [showStatus, setShowStatus] = React.useState(false)
  //   const [statusIcon, setStatusIcon] = React.useState("inProgress")
    const [documentData, setDocumentData] = React.useState<[]>([])
  //   const [loading, setLoading] = React.useState(false)
  //   const [active, setActive] = React.useState<boolean>(true)
    const [fileName, setFileName] = React.useState<string>("")
    const [createLoading, setCreateLoading] = React.useState<boolean>(false)
  //   
  
    const { document } = useAppSelector((state) => state.documentDMS)
    const dispatch = useAppDispatch()
    const usernameToken = decoded?.Username ? decoded.Username : ""
    const userIdToken = decoded?.UserId ? decoded.UserId : ""

  
    if (!showStatus && currentFiles.length > 0) {
      setShowStatus(true)
    }
  
    React.useEffect(() => {
      const fetchData = async () => {
        await dispatch(fetchDocumentByUser())
      }
      fetchData()
    }, [dispatch])
  
    React.useEffect(() => {
      if (document) {
        const documentItems = document.filter(
          (item: any) => item.type !== "EMPLOYMENT_REFERENCE"
        )
        setDocumentData(documentItems)
      }
    }, [document])
  
    const removeFiles = (namesOfFilesToRemove: string[]) => {
      const newCurrentFiles = userFiles.filter(
        (currentFile) =>
          !namesOfFilesToRemove.some((fileName) => fileName === currentFile.name)
      )
      setUserFiles(newCurrentFiles) //
      setCurrentFiles(newCurrentFiles)
  
      const newReadFiles = readFileData.filter(
        (readFile) =>
          !namesOfFilesToRemove.some((fileName) => fileName === readFile.fileName)
      )
  
      setReadFileData(newReadFiles)
    }
  
    const handleReadSuccess = (data: string, file: File) => {
      setReadFileData((prevReadFiles) => [
        ...prevReadFiles,
        {
          data,
          fileName: file.name,
          loadResult: "success",
        },
      ])
    }
  
    const handleReadFail = (error: DOMException, file: File) => {
      setReadFileData((prevReadFiles) => [
        ...prevReadFiles,
        {
          loadError: error,
          fileName: file.name,
          loadResult: "danger",
        },
      ])
    }
  
    const filterBySize = (file: any) => {
      return file[0].size <= MAX_FILE_SIZE
    }
  
    const handleFileSelection = (
      e: React.ChangeEvent<HTMLInputElement>,
      type: string
    ) => {
      let files = e.target.files
      let idstokeep = [0, 2]
      const checkSize = filterBySize(files)
  
      if (checkSize === true) {
        let droppedFile = Array.prototype.slice
          .call(files)
          .splice(idstokeep[0], idstokeep[1])
  
        const currentFileNames = userFiles.map((file) => file.name)
  
        const reUploads = droppedFile.filter((file) => {
          file.typeUpload = type
          return currentFileNames.includes(file.name)
        })
  
        Promise.resolve()
          .then(() => removeFiles(reUploads.map((file) => file.name)))
          .then(() =>
            setUserFiles((prevFiles) => {
              return [...prevFiles, ...droppedFile]
            })
          )
      } else {
        Swal.fire({
          icon: "error",
          title: `${t("Error")}`,
          text: `${t("text_check_image_hight_2mb")}`,
          confirmButtonText: `${t("ok")}`,
        })
      }
      e.target.value = ""
    }
  
    const onSubmit = async (data: any) => {
      setCreateLoading(true)

      const formData = new FormData()
      formData.append("uploadType", "employmentDocs")
      formData.append("businessPlace", "Betagro")
      formData.append("company", "Betagro")
      formData.append("nameFile", fileName)
      formData.append("createBy", usernameToken)
      formData.append("userId", userId)

      for (let item in userFiles) {
        let type: any = userFiles[item]
        formData.append(type?.typeUpload, userFiles[item])
      }
      try {
        if (userId && userFiles && userFiles.length > 0) {
          const resFilesDoc = await sendFilesDocuments(formData, userIdToken)

          if (resFilesDoc && resFilesDoc.status === 200) {
            setCreateLoading(false)
            await dispatch(fetchDocumentByUser())
            setUserFiles([])
            Swal.fire({
              icon: "success",
              title: `${t("Update status successful!")}`,
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              onClose(true)
              window.location.reload()
            })
          } else {
            if (resFilesDoc.status === 413) {
              setCreateLoading(false)
              const currentFile =
                userFiles &&
                userFiles.filter(
                  (file) =>
                    file?.type === "image/png" || file?.type === "image/jpg"
                )
              Swal.fire({
                icon: "warning",
                title: `${t("ERROR_MESSAGES.title")}`,
                text: `[${resFilesDoc.status}] ${t(
                  "ERROR_MESSAGES.description"
                )}`,
                confirmButtonText: `${t("ok")}`,
              }).then((result) => {
                if (result.isConfirmed) {
                  setUserFiles(currentFile)
                }
              })
            } else {
              setCreateLoading(false)
              const currentFile =
                userFiles &&
                userFiles.filter(
                  (file) =>
                    file?.type === "image/png" || file?.type === "image/jpg"
                )
              Swal.fire({
                icon: "warning",
                text: `${t("text_err_400_to_upload_file")} [${
                  resFilesDoc.status
                }]`,
                confirmButtonText: `${t("ok")}`,
              }).then((result) => {
                if (result.isConfirmed) {
                  setUserFiles(currentFile)
                }
              })
            }
          }
        } else {
          setCreateLoading(false)
          onClose(true)

          Swal.fire({
            icon: "warning",
            text: `${t("text_choose_image_before_click_upload")}`,
            confirmButtonText: `${t("ok")}`,
          })
        }
      } catch (error) {
        setCreateLoading(false)
      }
    }

    const handleStatusFile = (type: string) => {
      return type === "docsFile" ? "text_types_file_docs" : ""
    }

    return (
      <ThemeProvider theme={theme}>
        <Dialog
          sx={{
            "& .MuiDialog-paper": {
              width: "80%",
              height: "60%",
              position: "relative",
              padding: themeUI.spacing(2),
              display: "flex",
              flexDirection: "column",
              [themeUI.breakpoints.up("md")]: {
                width: "50%",
                height: "60%",
              },
              [themeUI.breakpoints.up("lg")]: {
                width: "50%",
                height: "60%",
              },
            },
          }}
          open={open}
          {...other}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "70px",
              flexShrink: 0,
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              {t("text_btn_upload_file_docs")}
            </Typography>
          </Box>

          <Box
            component="form"
            noValidate
            sx={{
              mt: 3,
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
            }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid container spacing={3}>
              <Grid item lg={12} xs={12} sm={12} md={12}>
                <div
                  className={`custom-file-upload ${
                    userFiles.length > 0 ? "disabled-upload" : ""
                  }`}
                >
                  <CloudUploadIcon className="upload-icon" />
                  {t("text_contract_file_name")}
                  <input
                    type="file"
                    id="docsFile"
                    className="file-input"
                    accept=".pdf, .doc,.docx"
                    disabled={userFiles.length > 0}
                    onChange={(event) => {
                      handleFileSelection(event, "docsFile")
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item lg={12} xs={12} sm={12} md={12}>
                <MultipleFileUpload>
                  {userFiles.map((file: any, index: number) => (
                    <div key={index}>
                      <MultipleFileUploadStatusItem
                        className="file-upload-show"
                        file={file}
                        fileName={`${t(
                          `${handleStatusFile(file.typeUpload)}`
                        )} : ${file.name}`}
                        key={file.name}
                        onClearClick={() => removeFiles([file.name])}
                        onReadSuccess={handleReadSuccess}
                        onReadFail={handleReadFail}
                        fileIcon={<UploadFileIcon color="secondary" />}
                      />
                    </div>
                  ))}
                </MultipleFileUpload>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={3}
              sx={{ mt: "auto", paddingTop: themeUI.spacing(2) }}
            >
              {" "}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  sx={{ mt: 0, mb: 0, color: "white" }}
                  disabled={createLoading}
                >
                  {t("Create")}
                  {createLoading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        zIndex: 999,
                      }}
                    />
                  )}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 0, mb: 0 }}
                  onClick={() => {
                    onClose(true)
                  }}
                >
                  {t("Cancel")}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      </ThemeProvider>
    )
}
